import { SessionStorageEntityIdResolver } from '../../resolvers/session-storage-entityid/session-storage-entityid.resolver';

export const loginRoute = {
  // The URL stays /login even though the page shown is the maintenance page:
  // Auth0's allowed logout URLs and guard redirects across the app point here,
  // and LoginGuard redirects everyone away unless the API is unreachable.
  path: 'login',
  url: '/login',
  resolve: {
    entityId: SessionStorageEntityIdResolver,
  },
  loadChildren: () => import('../../../shell/maintenance-page/maintenance-page.module').then(m => m.MaintenancePageModule),
};
